import { EntityTypeEnum } from 'common/enums/entityTypeEnum'
import { BorderStyleEnum } from 'common/types/styleTypes'
import { generateEntity } from 'src/shared/entities/utils/generate-base-entity'
import { MasterBlockIdType } from 'src/shared/schemas/master-block-id.schema'
import { ContactUsButtonEntityInterface } from './contact-us-button-entity.schema'

export const createContactUsButton = (
  parentId: string,
  text: string,
  masterBlockId?: MasterBlockIdType,
): ContactUsButtonEntityInterface => ({
  ...generateEntity(EntityTypeEnum.ContactUsButton, parentId, masterBlockId),
  textFontSize: 20,
  subTextFontSize: 14,
  textColor: 'rgba(255, 255, 255, 1)',
  background: 'rgba(1, 160, 255, 1)',
  alignSelf: 'center',
  text,
  border: {
    radius: 5,
    style: BorderStyleEnum.none,
  },
  padding: {
    paddingTop: 15,
    paddingRight: 90,
    paddingBottom: 15,
    paddingLeft: 90,
  },
})
